// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__M5fsu","head":"ProcedureTableInfo_head__2gffg"};